import script from "./InclusiveNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./InclusiveNotice.vue?vue&type=script&setup=true&lang=js"

import "./InclusiveNotice.vue?vue&type=style&index=0&id=ad039490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad039490"]])

export default __exports__